/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from 'moment';
import * as types from './types';

export const state = {
  load: false,
  twofa: false,
  id: '',
  client_ref: '',
  token: '',
  color: 'primary',
  logoLink: '',
  stylized: false,
  partner: '',
  account_id: '',
  email: '',
  successStatus: false,
  errorStatus: false,
  errorMessage: '',
  getCredencialsResponse: {},
};

export const mutations = {
  [types.LOAD](state, load) {
    state.load = load;
  },
  [types.TWOFA](state, twofa) {
    state.twofa = twofa;
  },
  [types.ID](state, id) {
    state.id = id;
  },
  [types.CLIENT_REF](state, client_ref) {
    state.client_ref = client_ref;
  },
  [types.TOKEN](state, token) {
    state.token = token;
  },
  [types.COLOR](state, color) {
    state.color = color;
  },
  [types.LOGO_LINK](state, logoLink) {
    state.logoLink = logoLink;
  },
  [types.STYLIZED](state, stylized) {
    state.stylized = stylized;
  },
  [types.PARTNER](state, partner) {
    state.partner = partner;
  },
  [types.ACCOUNT_ID](state, account_id) {
    state.account_id = account_id;
  },
  [types.EMAIL](state, email) {
    state.email = email;
  },
  [types.SUCCESS_STATUS](state, successStatus) {
    state.successStatus = successStatus;
  },
  [types.ERROR_STATUS](state, errorStatus) {
    state.errorStatus = errorStatus;
  },
  [types.ERROR_MESSAGE](state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  [types.GET_CREDENCIALS_RESPONSE](state, getCredencialsResponse) {
    state.getCredencialsResponse = getCredencialsResponse;
  },
};
